export const getVATAndPriceWithVAT = (price: number, vatRate: number) => {
  const vat = price * (vatRate / 100);
  const priceWithVAT = price + vat;
  return { vat, priceWithVAT };
};
